import { escapeEmptyDetail } from '../../utils/utils';
import DetailItem from '../DetailItem/DetailItem';

const PayloadBuilderObject = (props) => {

  const payload = props.payload;
  
  const getElements = () => {
    let elements = [];
    
    for (const [key, value] of Object.entries(payload)) {
    if(key !== null) 
      elements.push(
        <p key={key}><b>{escapeEmptyDetail(key)}:</b> {escapeEmptyDetail(value)}</p>
      )
    }

    return elements;
  }

  return (
    <DetailItem title={props.title} content={getElements()} />
  );
};

export default PayloadBuilderObject